export function LogoMark() {
  return (
    <svg
      fill="none"
      height="40"
      viewBox="0 0 40 40"
      width="40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.0076 16.8652C30.5082 17.0034 29.9847 17.114 29.442 17.1923C26.5132 17.6211 23.6702 18.078 20.8478 18.5315C16.0892 19.2963 11.3888 20.0517 6.43297 20.6473C3.08559 21.0481 2.09626 18.4868 2.02903 16.1696C1.93298 12.6823 2.5525 8.58238 3.45538 5.18724C4.18537 2.44626 5.67416 -0.0183241 9.18963 0.000102674C14.775 0.0277429 20.3315 0.654254 25.8641 1.34986C28.1837 1.64009 30.4937 2.14682 32.6213 3.0958C35.2099 4.25208 36.9676 6.55543 36.9676 9.3517C36.9676 13.3411 34.5903 15.8702 31.0028 16.8652H31.0076Z"
        fill="currentColor"
      />
      <path
        d="M30.5117 40H6.47014C4.67399 40 2.69053 39.4288 1.40825 38.1481C-0.291849 36.4574 -0.0805373 34.2693 0.164393 32.164C0.198226 31.8766 0.229628 31.5885 0.261044 31.3004C0.354494 30.4432 0.448082 29.5847 0.606228 28.7366C0.985629 26.6913 1.78766 24.6873 4.09768 24.0009C6.37219 23.3253 9.0532 22.9271 11.4596 22.5696C11.6292 22.5444 11.7976 22.5194 11.9643 22.4945C12.5311 22.4099 13.098 22.3247 13.6649 22.2396L13.6669 22.2393C17.0475 21.7315 20.4306 21.2233 23.8314 20.8131C24.1615 20.7731 24.4945 20.7309 24.8299 20.6885C27.8903 20.3012 31.1431 19.8896 34.0992 20.8361C37.802 22.0201 39.4829 25.7377 39.9151 29.2019C40.6307 34.8912 36.7646 40 30.5117 40Z"
        fill="currentColor"
      />
    </svg>
  );
}
